import isPropValid from '@emotion/is-prop-valid'
import { INSPECT_OVERLAY_ATTRS } from '@storefronts/common-types'
import { forwardRef } from 'react'

/**
 * Light-DOM host live-edit stamps as overlay chrome. Emotion's styled helper
 * in this repo has no `.attrs`, so styled overlay surfaces wrap this instead.
 *
 * Emotion only drops non-DOM props when the styled target is an element, so
 * every `styled(InspectOverlayHost)` would otherwise forward its own style props
 * to the div and make React warn. Filtering here gives those overlays the same
 * behavior they would get from `styled.div`.
 *
 * React warns once per attribute name per module registry, so a test that
 * asserts on these warnings only catches the first leak of a given name. That
 * is why each overlay that could leak is covered in its own test file rather
 * than as cases in a shared one — merging them would silently disarm all but
 * the first.
 */
export const InspectOverlayHost = forwardRef<
    HTMLDivElement,
    React.HTMLAttributes<HTMLDivElement>
>(function InspectOverlayHost(props, ref) {
    const domProps = Object.fromEntries(
        Object.entries(props).filter(([prop]) => isPropValid(prop)),
    )

    return <div ref={ref} {...INSPECT_OVERLAY_ATTRS} {...domProps} />
})
